import { FETCH_ALL_WOO_LOCATION_PAGES, FETCH_SINGLE_WOO_LOCATION_PAGE, UPDATE_WOO_LOCATION_PAGE, CREATE_WOO_LOCATION_PAGE, DELETE_WOO_LOCATION_PAGE,PUBLISH_LOCATION_PAGE,GENERATE_LOCATION_PAGE_CONTENTS_OPENAI} from '../actions';
const initialState = {
  wooLocationPages: [],
  wooSingleLocationPage: {},
  addWooLocationPage: {},
  deleteWooSeoPage:{},
  statusChangeWooLocationPage:{},
  generatedLocationPageContents:{},
  updatedLocationPage:{},
};  


function wooSeoReducer(state = initialState, action) {
  let wooLocationPages, wooSingleLocationPage, addWooLocationPage, addWooLocationPageError, deleteWooSeoPage,statusChangeWooLocationPage,generatedLocationPageContents,updatedLocationPage;
  switch (action.type) {
    case `${FETCH_ALL_WOO_LOCATION_PAGES}_PENDING`:
    case `${FETCH_SINGLE_WOO_LOCATION_PAGE}_PENDING`:
    case `${CREATE_WOO_LOCATION_PAGE}_PENDING`:
    case `${DELETE_WOO_LOCATION_PAGE}_PENDING`:
    case `${PUBLISH_LOCATION_PAGE}_PENDING`:     
    case `${GENERATE_LOCATION_PAGE_CONTENTS_OPENAI}_PENDING`:   
    case `${UPDATE_WOO_LOCATION_PAGE}_PENDING`:   
      return { ...state, 
        loading: true,
    };
    case `${FETCH_ALL_WOO_LOCATION_PAGES}_FULFILLED`:
      wooLocationPages = action.payload.data;
      return { ...state, loading: false, wooLocationPages };

    case `${FETCH_SINGLE_WOO_LOCATION_PAGE}_FULFILLED`:
      wooSingleLocationPage = action.payload.data;
        return { ...state, loading: false, wooSingleLocationPage };

    case `${CREATE_WOO_LOCATION_PAGE}_FULFILLED`:
      addWooLocationPage = action.payload.data;
        return { ...state, loading: false, addWooLocationPage };        
 
    case `${DELETE_WOO_LOCATION_PAGE}_FULFILLED`:
      deleteWooSeoPage = action.payload.data;
        return { ...state, loading: false, deleteWooSeoPage }; 

    case `${PUBLISH_LOCATION_PAGE}_FULFILLED`:
      statusChangeWooLocationPage = action.payload.data;
        return { ...state, loading: false, statusChangeWooLocationPage };

    case `${GENERATE_LOCATION_PAGE_CONTENTS_OPENAI}_FULFILLED`:
      generatedLocationPageContents = action.payload.data;
        return { ...state, loading: false, generatedLocationPageContents };

   case `${UPDATE_WOO_LOCATION_PAGE}_FULFILLED`:
     updatedLocationPage = action.payload.data;
        return { ...state, loading: false, updatedLocationPage };

    case `${FETCH_ALL_WOO_LOCATION_PAGES}_REJECTED`:
        return {...state, loading: false, wooLocationPagesError: action.payload.response.data, state: initialState };

    case `${FETCH_SINGLE_WOO_LOCATION_PAGE}_REJECTED`:
          return {...state, loading: false, wooSingleLocationPageError: action.payload.response.data, state: initialState };  

    case `${CREATE_WOO_LOCATION_PAGE}_REJECTED`:
          return {...state, loading: false,addWooLocationPageError: action.payload.response.data, state: initialState };

    case `${DELETE_WOO_LOCATION_PAGE}_REJECTED`:
        return {...state, loading: false,deleteWooSeoPageError: action.payload.response.data, state: initialState };    
       
    case `${PUBLISH_LOCATION_PAGE}_REJECTED`:
      return {...state, loading: false, statusChangeWooLocationPageError: action.payload.response.data, state: initialState };   

    case `${GENERATE_LOCATION_PAGE_CONTENTS_OPENAI}_REJECTED`:
      return {...state, loading: false, generatedLocationPageContentsError: action.payload.response.data, state: initialState };  

    case `${UPDATE_WOO_LOCATION_PAGE}_REJECTED`:
        return {...state, loading: false, updatedLocationPageError: action.payload.response.data, state: initialState };  
    
    default:
      return state;
  }
}

export default wooSeoReducer;
